import {
  Building2,
  FileText,
  LayoutDashboard,
  Package,
  ShoppingBag,
  Truck,
} from "lucide-react";

export const SUPPLIER_NAV_ITEMS = [
  { to: "/supplier", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/supplier/businesses", label: "Businesses", icon: Building2 },
  { to: "/supplier/products", label: "Products", icon: Package },
  { to: "/supplier/rfqs", label: "RFQs", icon: FileText },
  { to: "/supplier/orders", label: "Orders", icon: ShoppingBag },
  { to: "/supplier/deliveries", label: "Deliveries", icon: Truck },
];

const ROUTE_LABELS = [
  ["/supplier/notifications", "Notifications"],
  ["/supplier/settings", "Settings"],
  ["/supplier/businesses", "Businesses"],
  ["/supplier/products", "Products"],
  ["/supplier/rfqs", "RFQs"],
  ["/supplier/orders", "Orders"],
  ["/supplier/deliveries", "Deliveries"],
];

export function supplierBreadcrumb(pathname) {
  if (pathname === "/supplier" || pathname === "/supplier/") {
    return [{ label: "Dashboard" }];
  }

  const match = ROUTE_LABELS.find(([prefix]) => pathname.startsWith(prefix));
  return [{ label: match?.[1] || "Supplier Portal" }];
}
